import { useState } from "react";
import { Divider, IconButton, Menu, MenuItem } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu"; // removed unused
// import { useUIContext } from "../../../state/ui"; // drawer not used here currently
import { AccountCircle } from "@mui/icons-material";
import UserProfileDialog from "../../user/userProfileDialog";
import useDialogModal from "../../../hooks/useDialogModal";
import { useAuth } from '../../../hooks/useAuth';

function AccountMenu() {
  const [UserProfileDialogComp, showUserProfileDialog] = useDialogModal(UserProfileDialog);
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, logout } = useAuth();

  // Drawer open and extra menu handlers removed as unused after auth integration

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    showUserProfileDialog()
    //setOpen(true)
    handleClose()
  }
  return (
    <>

      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        sx={{
          color: "#fff",
        }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        elevation={1}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfile}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>Account</MenuItem>
        <Divider />
        <MenuItem onClick={() => { handleClose(); logout(); }}>Logout</MenuItem>
      </Menu>

      <UserProfileDialogComp user={user ? user : null} />
    </>
  );
}

export default AccountMenu;
